
export default {
  name: "NonAvailabilityGroupEditModal",
  props: {
    baseUrl: { type: String, required: true },
    recurrenceGroupId: { type: String, required: true },
    allRecords: { type: Array, required: true },
    nonAvailabilityTypes: { type: Array, required: true }
  },
  emits: ["close", "saved"],
  data() {
    const groupRecords = (this.allRecords as any[]).filter((r: any) => r.recurrenceGroupId === this.recurrenceGroupId);
    const earliest = groupRecords
      .map((r: any) => new Date(r.nonAvailabilityDate))
      .sort((a: Date, b: Date) => a.getTime() - b.getTime())[0] || new Date();
    return {
      currentMonth: this.startOfMonth(earliest),
      stagedDates: new Set<string>(groupRecords.map((r: any) => (r.nonAvailabilityDate || "").split("T")[0])),
      selectedTypeId: (groupRecords[0] && groupRecords[0].nonAvailabilityTypeId) || null,
      reason: (groupRecords[0] && groupRecords[0].reason) || "",
      loading: false,
      message: "",
      messageType: "",
      weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    };
  },
  computed: {
    monthLabel(): string {
      return this.currentMonth.toLocaleDateString(undefined, { month: "long", year: "numeric" });
    },
    otherRecordsByKey(): Record<string, any> {
      const map: Record<string, any> = {};
      for (const record of this.allRecords as any[]) {
        if (record.recurrenceGroupId !== this.recurrenceGroupId) {
          map[(record.nonAvailabilityDate || "").split("T")[0]] = record;
        }
      }
      return map;
    },
    calendarWeeks(): any[][] {
      const firstOfMonth = this.currentMonth;
      const firstWeekday = (firstOfMonth.getDay() + 6) % 7;
      const gridStart = new Date(firstOfMonth);
      gridStart.setDate(gridStart.getDate() - firstWeekday);

      const weeks: any[][] = [];
      const cursor = new Date(gridStart);
      for (let w = 0; w < 6; w++) {
        const week: any[] = [];
        for (let d = 0; d < 7; d++) {
          const date = new Date(cursor);
          const key = this.formatDateKey(date);
          week.push({
            key,
            date,
            day: date.getDate(),
            inCurrentMonth: date.getMonth() === firstOfMonth.getMonth(),
            otherRecord: this.otherRecordsByKey[key] || null
          });
          cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
      }
      return weeks;
    }
  },
  methods: {
    startOfMonth(date: Date): Date {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    },
    formatDateKey(date: Date): string {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    },
    previousMonth() {
      this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
    },
    nextMonth() {
      this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
    },
    cellClass(cell: any) {
      return {
        "calendar-cell-outside": !cell.inCurrentMonth,
        "calendar-cell-staged": !cell.otherRecord && this.stagedDates.has(cell.key),
        "calendar-cell-other-group": !!cell.otherRecord
      };
    },
    onCellClick(cell: any) {
      if (!cell.inCurrentMonth || this.loading || cell.otherRecord) {
        return;
      }
      if (this.stagedDates.has(cell.key)) {
        this.stagedDates.delete(cell.key);
      } else {
        this.stagedDates.add(cell.key);
      }
    },
    authHeaders() {
      const token = localStorage.getItem("token");
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    },
    cancel() {
      this.$emit("close");
    },
    async save() {
      if (!this.selectedTypeId) {
        return;
      }
      this.loading = true;
      this.message = "";
      try {
        const dates = Array.from(this.stagedDates).sort();
        const response = await fetch(`${this.baseUrl}SecurityOfficers/NonAvailability/Group/${this.recurrenceGroupId}/Update`, {
          method: "POST",
          headers: this.authHeaders(),
          body: JSON.stringify({
            Dates: dates,
            NonAvailabilityTypeId: this.selectedTypeId,
            Reason: this.reason
          })
        });
        if (response.ok) {
          this.$emit("saved");
        } else {
          this.message = "Failed to save changes.";
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error("Error saving non-availability group:", error);
        this.message = "Network error while saving changes.";
        this.messageType = "alert-danger";
      } finally {
        this.loading = false;
      }
    }
  }
};
